import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import Video from '../../../common/components/Video';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import './ProductPics.css';

export default function ProductPics(props) {
  const { demoVideoLink, linktivityName, picURLs } = props;
  const [images, setImages] = useState([]);
  const videoRef = useRef();

  const renderVideo = (item) => {
    return (
      <Video
        videoSrcURL={item.embedUrl}
        videoTitle={item.linktivityName}
        videoRef={videoRef}
      ></Video>
    );
  };

  const resetVideo = (element) => {
    var iframeSrc = element.src;
    element.src = iframeSrc;
  };

  const handleSlide = (index) => {
    //if not sliding to the video, the reset to stop playing and start over
    if (index !== 0) {
      resetVideo(videoRef.current);
    }
  };

  useEffect(() => {
    let tempImages = [];
    tempImages.push({
      thumbnail: process.env.PUBLIC_URL + '/circle-play_1.png',
      embedUrl: demoVideoLink,
      linktivityName: linktivityName,
      renderItem: renderVideo.bind(this),
    });
    picURLs &&
      picURLs.forEach((picUrl) => {
        tempImages.push({
          original: picUrl,
          thumbnail: picUrl,
        });
      });
    setImages(tempImages);
  }, [picURLs, demoVideoLink, linktivityName]);

  return (
    <>
      <ImageGallery
        items={images}
        showFullscreenButton={false}
        showPlayButton={false}
        onSlide={handleSlide}
      ></ImageGallery>
    </>
  );
}
